import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { ContactsService } from '@app/modules/portfolio/services/contacts.service';
import { QuangularToasterService } from '@app/services/common/toaster.service';
import { REGEX } from '@common/constants/regex.constant';
import { ApiStatusCode } from '@common/enums/ApiStatusCode';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-add-contact',
  templateUrl: './add-contact.component.html',
  styleUrls: ['./add-contact.component.scss', '../user-details/user-details.component.scss']
})
export class AddContactComponent implements OnDestroy {
  email: string = '';
  emailPattern: string = REGEX.EMAIL_PATTERN;
  @Input() addContactDetails ;
  @Output() closeDialog = new EventEmitter<any>();
  private subscription: Subscription = new Subscription();

  constructor(private readonly contactsService: ContactsService,
    private readonly qToaster: QuangularToasterService
  ) { }

  closeModal(){
    this.closeDialog.emit(null);
  }
  saveContact(){
    if(!this.email){
         this.qToaster.showToast({
          message: 'Email not found',
          status: "error"
        });
    }
    // check if its a valid user or not 
    this.subscription.add(this.contactsService.getUserByEmail(this.email).subscribe({
        next: (data: any) => {
          if(data?.isGuestNotFound){
              this.qToaster.showToast({
                message: 'User not found in Azure AD',
                status: "error"
              });
              return;
          }
          else{
            this.addContact(data);
          }
        }
      }));
  }
  addContact(data){
    let payload = {
      ...this.addContactDetails,
      email: this.email,
      user: data
    };
    this.subscription.add(this.contactsService.addContact(payload).subscribe({
      next: (res) => {
        if (res?.status == ApiStatusCode.Success) {
          this.closeDialog.emit(res);
        } else {
          this.qToaster.showToast({
            message: res.message,
            status: res?.status
          });
        }
      },
      error: (err) => {
        this.qToaster.showToast({
          message: err.message,
          status: "error"
        });
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
